import { render, staticRenderFns } from "./NetworkManagement.vue?vue&type=template&id=36c4e3ec&"
import script from "./NetworkManagement.vue?vue&type=script&lang=js&"
export * from "./NetworkManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports